







export default {
  name: "EhrIcon",
  props: {
    iconCollection: {
      type: String as () => 'far' | 'fas' | 'fad',
      required: false,
      default: 'fad'
    },
    icon: {
      type: String,
      required: true
    },
    primary: {
      type: Boolean,
      required: false
    },
  }
}
